export default __webpack_public_path__ + "static/media/laptop.4b0d8235.png";